import { DialogElement as DialogElement } from "//www.pimentaedrinks.com/cdn/shop/t/28/assets/theme.js?v=117532895566618988011712224428";
import { Delegate as Delegate } from "//www.pimentaedrinks.com/cdn/shop/t/28/assets/vendor.min.js?v=56430842210900357591712224180";
var AgeCheckPopup = class extends DialogElement {
  connectedCallback() {
    super.connectedCallback();
    this.delegateElement = new Delegate(this);

    this.delegateElement.on("click", '[data-action="accept"]', (event) => {
      console.log("Accept");
      localStorage.setItem("age-check:passed", true);
      this.hide();
    });

    if (!this.hasAccepted) {
      setTimeout(() => this.show(), 0);
    }
  }

  get initialFocus() {
    return false;
  }

  get shouldAppendToBody() {
    return false;
  }

  get hasAccepted() {
    return localStorage.getItem("age-check:passed") !== null;
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (name === "open" && this.open) {
      localStorage.setItem("theme:popup-appeared", "true");
    }
  }
};

if (!window.customElements.get("age-check-popup")) {
  window.customElements.define("age-check-popup", AgeCheckPopup);
}